import styled from 'styled-components';
import { Button, Table } from 'antd';
import { Box, Flex, Text } from 'atoms';
import { ButtonWrapper } from 'components';

// Styled Components
export const PageContainer = styled(Box)`
	max-width: 1600px;
	margin: 0 auto;
	padding: 24px;
	background: #f4f6f8;
	min-height: 100vh;
`;

export const FormContainer = styled(Box)`
	background: #fff;
	border: 1px solid #e8e8e8;
	border-radius: 8px;
	padding: 32px 40px;
	margin-bottom: 24px;
`;

export const SectionTitle = styled(Text)`
	font-size: 20px;
	font-weight: 600;
	color: #333;
	display: block;
	margin-bottom: 8px;
`;

export const SectionSubtitle = styled(Text)`
	font-size: 14px;
	color: #666;
	display: block;
	margin-bottom: 24px;
`;

export const FormRow = styled(Flex)`
	margin-bottom: 24px;
	gap: 24px;

	&:last-of-type {
		margin-bottom: 0;
	}
`;

export const FormItem = styled(Box)`
	flex: 1;

	.ant-form-item-label {
		padding-bottom: 8px;

		label {
			font-size: 13px;
			font-weight: 500;
			color: #333;

			&::before {
				display: none !important;
			}
		}

		label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::after {
			display: inline-block;
			margin-left: 4px;
			color: #ff4d4f;
			font-size: 13px;
			line-height: 1;
			content: '*';
		}
	}

	.ant-input,
	.ant-select-selector,
	.ant-picker {
		border-radius: 4px;
		height: 40px;
		font-size: 13px;
	}
`;

export const BrowseButton = styled(Button)`
	background: #18405d;
	border-color: #18405d;
	color: #fff;
	height: 40px;
	padding: 0 24px;
	font-weight: 500;
	border-radius: 4px;

	&:hover {
		background: #1e4a6b;
		border-color: #1e4a6b;
		color: #fff;
	}
`;

export const AddDriverButton = styled(Button)`
	background: #18405d;
	border-color: #18405d;
	color: #fff;
	height: 40px;
	padding: 0 32px;
	font-weight: 500;
	border-radius: 4px;
	margin-top: 24px;

	&:hover {
		background: #1e4a6b;
		border-color: #1e4a6b;
		color: #fff;
	}
`;

export const StyledTable = styled(Table)`
	background: #fff;
	border-radius: 8px;
	overflow: hidden;
	margin-top: 24px;

	.ant-table-thead > tr > th {
		background: #18405d;
		color: #fff;
		font-weight: 600;
		padding: 12px 16px;
		font-size: 13px;
	}

	.ant-table-tbody > tr > td {
		padding: 12px 16px;
		font-size: 13px;
	}

	.ant-table-tbody > tr:hover > td {
		background: #f5f5f5;
	}
`;

export const SubmitButton = styled(Button)`
	background: #18405d;
	border-color: #18405d;
	color: #fff;
	height: 40px;
	padding: 0 32px;
	font-weight: 500;
	border-radius: 4px;
	margin-top: 24px;

	&:hover {
		background: #1e4a6b;
		border-color: #1e4a6b;
		color: #fff;
	}
`;

export const HeaderSection = styled(Flex)`
	justify-content: space-between;
	align-items: flex-start;
	margin-bottom: 24px;
`;

export const FileUploadContainer = styled(Box)`
	.ant-upload {
		width: 100%;
	}
`;

export const ViewButton = styled(ButtonWrapper)`
	padding: 4px;
	min-width: 32px;
	min-height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const BulkUploadButton = styled(ButtonWrapper)`
	border: 1px solid #18405d;
	border-radius: 4px;
	padding: 8px 20px;
	height: auto;
	font-weight: 500;

	&:hover {
		border-color: #18405d;
		background-color: rgba(24, 64, 93, 0.04);
	}
`;
